import { PROFILE_SCORE_API } from '../constants/configs';
import { API_REQUEST } from '../constants/general';
import { Actions } from '../redux/actions';
import API from '../utils/api';
import { dispatch } from '../utils/store';
import { handleError } from '../utils/toast';

export const handleProfileScore = (toastReff) => {
  dispatch(Actions.User.SetLoading, true);
  API(API_REQUEST.get, PROFILE_SCORE_API)
    .then((res) => {
      dispatch(Actions.User.SetLoading, false);
      dispatch(Actions.ProfileScore.SetProfileScore, res?.data?.data?.data?.totalScore || 0);
    })
    .catch((error) => {
      handleError(toastReff, error);
      dispatch(Actions.ProfileScore.ProfileScoreReset);
      dispatch(Actions.User.SetLoading, false);
      console.log(error);
    });
};
